export const MENU_COLLAPSED = '@n3/ls-layout/MENU_COLLAPSED';
export const OPENED_GROUPS = '@n3/ls-layout/OPENED_GROUPS';
